import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Helpers } from '@helpers';
import { ModelService, LanguageService } from '@viewservices';
import { map } from 'rxjs/operators';
import { AwareHttpRequest, AwareHttpService } from '@appbolaget/aware-http';
import { Unit } from '@appbolaget/aware-model';

@Injectable({ providedIn: 'root' })
export class UnitService extends ModelService<Unit> {
    activeUnit: Unit;
    model: Unit = new Unit();

    private _unit: BehaviorSubject<Unit> = new BehaviorSubject<Unit>(null);
    unit$ = this._unit.asObservable();

    constructor(
        public api: AwareHttpService,
        private languageService: LanguageService,
    ) {
        super(api);
    }

    setActiveUnit(unit: Unit) {
        this._unit.next(unit);
    }

    newAutocomplete(filter: any = false, options: any = {}) {
        if (filter) {
            // filter.sort = this.model.sorting;
        }

        return this.api
            .get(Unit.searchRoute)
            .parameters(
                options.params
                    ? options.params
                    : {
                          query: filter.search,
                          stream: 'down',
                          scope: 'units',
                          expand: 'parent',
                      },
            )
            .header('language', this.languageService.activeApiLanguage)
            .module('')
            .execute()
            .pipe(
                map((res) => {
                    const data: any = [];

                    this._pushUnits(res['data'], data);

                    return data;
                }),
            );
    }

    getHighestParentFromUnit(unit: Unit): Unit {
        if (!unit.parent) {
            return unit;
        }

        return this.getHighestParentFromUnit(unit.parent);
    }

    restore(unit: Unit): Observable<void> {
        return this.api.put(`units/${unit.uuid}/restore`, null).header('deleted', '*').execute();
    }

    saveInformation(values): AwareHttpRequest {
        if (values.meta) {
            values.meta = Helpers.prepareMetaForRequest(values.meta);
        }

        const unit = new Unit(values);
        return unit.save(this.api, { fields: ['title', 'type', 'content', 'hidden', 'public', 'meta'] });
    }

    _pushUnits(units: any = [], data) {
        if (!units?.length) {
            return;
        }

        for (const unit of units) {
            this._pushUnits(unit.children, data);

            const exists = data.filter((obj) => obj.uuid === unit.uuid).length > 0;

            if (!exists) {
                const model = new Unit(unit);

                data.push(model);
            }
        }
    }
}
